import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Axios from 'axios'

import * as firebase from 'firebase'

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(BootstrapVue);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAeCSbDY5ektI1Y4pquScX7OBjCi4mANnE",
    libraries: "places"
  }
});

Vue.prototype.$http = Axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    firebase.initializeApp({
      apiKey: "AIzaSyC1OgX-6o-Eo-2lgsAHJwBPc6ERvW_3lrA",
      authDomain: "polyfirenotes-efa16.firebaseapp.com",
      databaseURL: "https://polyfirenotes-efa16.firebaseio.com",
      projectId: "polyfirenotes-efa16",
      storageBucket: "polyfirenotes-efa16.appspot.com",
      messagingSenderId: "435128545699",
      appId: "1:435128545699:web:adbd7419b57ca69b"
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {

      }
    })
  }
}).$mount('#app')

// var firebaseConfig = {
//   apiKey: "AIzaSyD4o6pz-MFF8xkSU3IBFfeAAJZhq9WbjXw",
//   authDomain: "ptownapp-54a61.firebaseapp.com",
//   databaseURL: "https://ptownapp-54a61.firebaseio.com",
//   projectId: "ptownapp-54a61",
//   storageBucket: "ptownapp-54a61.appspot.com",
//   messagingSenderId: "1072876824257",
//   appId: "1:1072876824257:web:33bb44567eb33def365640"
// };

// apiKey: 'AIzaSyAoIn8ETsPWwLrlxaPFIwJ8JdIJuwkagzw',
//       authDomain: 'polyfirenotes-efa16.firebaseapp.com',
//       databaseURL: 'https://polyfirenotes-efa16.firebaseio.com',
//       projectId: 'polyfirenotes-efa16',
//       storageBucket: 'gs://polyfirenotes-efa16.appspot.com'

// apiKey: "AIzaSyC1OgX-6o-Eo-2lgsAHJwBPc6ERvW_3lrA",
//     authDomain: "polyfirenotes-efa16.firebaseapp.com",
//     databaseURL: "https://polyfirenotes-efa16.firebaseio.com",
//     projectId: "polyfirenotes-efa16",
//     storageBucket: "polyfirenotes-efa16.appspot.com",
//     messagingSenderId: "435128545699",
//     appId: "1:435128545699:web:adbd7419b57ca69b"